import { render, staticRenderFns } from "./LiveReportedComment.vue?vue&type=template&id=2f37ae78&"
import script from "./LiveReportedComment.vue?vue&type=script&lang=js&"
export * from "./LiveReportedComment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports